// A loaded visibility change invalidates every in-flight metrics request synchronously.
export default function employeeMetricScope(store) {
    let previous = store.getters.getEmployeeMetricsScope;
    store.subscribe(() => {
        const current = store.getters.getEmployeeMetricsScope;
        if (current === previous) return;
        previous = current;
        store.commit('resetVisibleDashboard');
        store.commit('resetVisibleBilling');
        store.commit('resetVisibleFinancial');
    });
}
